export const cities = [
  { id: '1', name: 'Islamabad' },
  { id: '2', name: 'Rawalpindi' },
  { id: '3', name: 'Taxila' },
  { id: '4', name: 'Peshawar' },
  { id: '5', name: 'Charsadda' },
  { id: '6', name: 'Mardan' },
  { id: '7', name: 'Swat' },
  { id: '8', name: 'Gilgit' },
  { id: '9', name: 'Lahore' },
  { id: '10', name: 'Faisalabad' },
  { id: '11', name: 'Sialkot' },
  { id: '12', name: 'Karachi' },
  { id: '13', name: 'Multan' },
  { id: '14', name: 'Hyderabad' },
  { id: '15', name: 'Quetta' },
  { id: '16', name: 'Nowshehra' },
  { id: '17', name: 'Swabi' },
  { id: '18', name: 'Abbottabad' },
  { id: '19', name: 'Skardu' },
  { id: '20', name: 'Murree' },
];
